import { type AdScreenOrientation } from '@/types/ad-telemetry'

export const getScreenOrientation = (): AdScreenOrientation =>
  window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape'

export const getIsPageVisible = () => document.visibilityState === 'visible'
